import { AvatarAPI, ButtonAPI} from '@philips-internal/oswald-ui-components';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ExamDetailsItemAliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
@Controller({ component: ExamDetailsItemAliases.LAYOUT_EXAM_DETAILS_ITEM, fragment: FragmentNames.EXAM_DETAILS_ITEM })
export default class ExamDetailsItemController extends BaseController {

  @Inject(ExamDetailsItemAliases.AVATAR)
    avatarAPI!: AvatarAPI;

  @Inject(ExamDetailsItemAliases.BUTTON_VIEW_PACS)
    viewImagesButtonAPI!: ButtonAPI;

  @OnMount(ExamDetailsItemAliases.CARD_CONTAINER_EXAM)
  handleExamCard(): void{
    this.viewImagesButtonAPI.setVisible(false);
    if(this.context.get('nrDicomAccess')){
      this.viewImagesButtonAPI.setVisible(true);
    }
  }

}
